import styled from 'styled-components';
import { colors, fonts, sizes, breakpoints } from '../theme';

export const StyledPageContainer = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${sizes.padding.lg} ${sizes.padding.lg};
  position: relative;
  margin-bottom: ${sizes.spacing.xl};
  ${breakpoints.media.mobile} {
    padding: ${sizes.padding.lg} ${sizes.padding.sm};
  }
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${sizes.layout.maxWidth};
  width: 100%;
  text-align: center;
`;


export const SocialMediaSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing.xl};
  margin-top: ${sizes.spacing.xl};
  align-items: center;
`;

export const GamesPageContainer = styled.section`
  min-height: 100vh;
  padding: 0;
  margin: 0;
  position: relative;
`;

export const AboutPageContainer = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  position: relative;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  margin-bottom: ${sizes.spacing.xl};
`;

export const AboutContentSection = styled.div`
  width: 100%;
  max-width: 100vw;
  background: ${colors.black};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    top: -150px;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(to bottom, transparent 0%, ${colors.blackTransparent[20]} 25%, ${colors.blackTransparent[40]} 50%, ${colors.black} 100%);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -150px;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(to top, transparent 0%, ${colors.blackTransparent[20]} 25%, ${colors.blackTransparent[40]} 50%, ${colors.black} 100%);
    pointer-events: none;
  }

  ${breakpoints.media.mobile} {
    &::before {
      top: -80px;
      height: 80px;
    }

    &::after {
      bottom: -80px;
      height: 80px;
    }
  }
`;

export const AboutHeaderImage = styled.img`
  width: 60%;
  max-width: 60%;
  height: auto;
  display: block;
  position: relative;
  z-index: 2;
`;

export const AboutContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${sizes.gap.xxl};
  max-width: ${sizes.layout.maxWidth};
  width: 100%;
  padding: ${sizes.gap.xxl} ${sizes.padding.lg} 0 ${sizes.padding.lg};
  align-items: center;
  box-sizing: border-box;

  ${breakpoints.media.tablet} {
    grid-template-columns: 1fr;
    gap: ${sizes.gap.xl};
    padding: ${sizes.gap.xl} ${sizes.padding.md};
  }

  ${breakpoints.media.mobile} {
    padding: ${sizes.padding.lg} ${sizes.padding.sm};
  }
`;

export const AboutLeftColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AboutGif = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;

  ${breakpoints.media.mobile} {
    max-width: 300px;
  }
`;

export const AboutRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AboutText = styled.p`
  color: ${colors.white};
  font-family: ${fonts.families.secondary};
  font-size: ${fonts.sizes.md};
  line-height: 1.8;
  margin: 0;
  padding: 1.25rem;
  white-space: pre-line;
  text-align: left;

  ${breakpoints.media.mobile} {
    font-size: ${fonts.sizes.sm};
    padding: 1rem;
    text-align: center;
  }
`;

export const TeamSection = styled.div`
  width: 100%;
  max-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${sizes.spacing.xl} ${sizes.padding.lg};
  margin-top: ${sizes.spacing.xl};
  box-sizing: border-box;

  ${breakpoints.media.mobile} {
    padding: ${sizes.spacing.lg} ${sizes.padding.sm};
  }
`;

export const TeamTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.gap.lg};
  margin-top: ${sizes.spacing.lg};
  ${breakpoints.media.mobile} {
    gap: ${sizes.gap.md};
  }
`;

export const TeamTitle = styled.h2`
  color: ${colors.white};
  font-family: ${fonts.families.primary};
  font-size: 3rem;
  font-weight: ${fonts.weights.bold};
  text-transform: ${fonts.textTransform.uppercase};
  letter-spacing: ${fonts.letterSpacing.wide};
  margin: 0;

  ${breakpoints.media.mobile} {
    font-size: 1.5rem;
  }
`;
